var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.50004 12C1.50004 12 0.518555 12 0.518555 11C0.518555 10 1.50004 7 6.40744 7C11.3149 7 12.2963 10 12.2963 11C12.2963 12 11.3149 12 11.3149 12H1.50004Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.40744 6C8.03362 6 9.35189 4.65685 9.35189 3C9.35189 1.34315 8.03362 0 6.40744 0C4.78127 0 3.463 1.34315 3.463 3C3.463 4.65685 4.78127 6 6.40744 6Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonFill);
export default __webpack_public_path__ + "static/media/PersonFill.9d9e99e224fa2dfed259d4d8be500828.svg";
export { ForwardRef as ReactComponent };